const VerifyTick = () => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 10.2879L7.30303 14.8333L14.5 6.5"
        stroke="#1FA009"
        strokeWidth="2.23125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default VerifyTick
